/* =======================================================================
      1) BLOQUEO ROBUSTO DE SLIDECART EN FUNNELS (SPA/BFCACHE/REACTIVO)
   ======================================================================= */
(function(){
  // Cualquier URL que contenga uno de estos fragmentos será tratada como funnel
  const BLOCK_KEYWORDS = [
    '/es/pages/skinny-coffee-en',
    '/es/pages/skinny-coffee',
    '/es/pages/ncb',
    '/pages/ncb',
    '/es/pages/collagen-protein-coffee-en',
    '/es/pages/ncb-vid',
    '/es/pages/skinny-coffee-m',
    '/pages/skinny-coffee-en-video',
    '/es/pages/collagen-protein-coffee',
    '/es/pages/skinny-coffee-s',
    '/pages/night-collagen-burn'
  ];

  function isReplo() {
    return location.hostname === 'dashboard.replo.app' &&
      /\/editor\/e1347caf-48d9-4ad8-aea0-936e60cca6ec\/c7bf5b8a-0416-4b38-afe1-2501ad9da809/.test(location.href);
  }

  function isBlocked() {
    const href = location.href;
    if (isReplo()) return true;
    return BLOCK_KEYWORDS.some(k => href.indexOf(k) !== -1);
  }

  function stubAPI() {
    window.SLIDECART_OPEN   = function(){};
    window.SLIDECART_TOGGLE = function(){};
    window.SLIDECART_UPDATE = window.SLIDECART_UPDATE || function(){};
  }

  function cancelEvents() {
    const stop = e => {
      try { e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation(); } catch(_) {}
    };
    document.addEventListener('SLIDECART_BEFORE_OPEN', stop, true);
    document.addEventListener('SLIDECART_OPENED',      stop, true);
    document.addEventListener('SLIDECART_OPEN',        stop, true);
    document.addEventListener('SLIDECART_TOGGLE',      stop, true);
  }

  function hideUI() {
    if (!document.getElementById('sc-blocker-style')) {
      const style = document.createElement('style');
      style.id = 'sc-blocker-style';
      style.textContent = `
        #slidecarthq, .slidecarthq { display:none !important; visibility:hidden !important; }
        html.slidecarthq-open, body.slidecarthq-open { overflow:auto !important; }
      `;
      document.head.appendChild(style);
    }
    const el = document.querySelector('#slidecarthq, .slidecarthq');
    if (el) {
      el.style.display = 'none';
      el.setAttribute('aria-hidden','true');
    }
    document.documentElement.classList.remove('slidecarthq-open');
    document.body.classList.remove('slidecarthq-open');
  }

  let mo = null;
  function startObserver() {
    if (mo) return;
    mo = new MutationObserver(() => {
      if (window.__SLIDECART_BLOCKED__) hideUI();
    });
    mo.observe(document.documentElement, {childList:true, subtree:true});
  }

  function applyBlock() {
    if (!isBlocked()) {
      window.__SLIDECART_BLOCKED__ = false;
      if (mo) { mo.disconnect(); mo = null; }
      return;
    }
    window.__SLIDECART_BLOCKED__ = true;
    console.log('[SC] Blocking SlideCart on funnel:', location.href);
    stubAPI();
    cancelEvents();
    hideUI();
    startObserver();
  }

  // Primera ejecución
  applyBlock();

  // Reaplicar en navegación SPA / back / forward / hash
  window.addEventListener('pageshow',   applyBlock);
  window.addEventListener('popstate',   applyBlock);
  window.addEventListener('hashchange', applyBlock);
  window.addEventListener('DOMContentLoaded', applyBlock);

  ['pushState','replaceState'].forEach(fn => {
    const orig = history[fn];
    history[fn] = function() {
      const r = orig.apply(this, arguments);
      applyBlock();
      return r;
    };
  });
})();

/* 🚫 Si estamos en funnel, no ejecutar nada del bundle */
if (window.__SLIDECART_BLOCKED__) {
  console.log('[SC] Drawer disabled on funnel page (bundle skipped)');
  // No seguir cargando la lógica de regalos / UI
} else {

/* =======================================================================
                        2) SLIDECART BUNDLE
   ======================================================================= */

// --- SlideCart Bundle JS ---
// Agrupa todo el comportamiento personalizado de Slidecart

document.addEventListener('DOMContentLoaded', () => {
  typeof disableSlideCart === 'function' && disableSlideCart();
  const NEW_TEXT = 'YOUR SKINNY COFFEE CART';

  function renameHeader () {
    const el = document.querySelector('#slidecarthq .header > span');
    if (!el) return false;
    el.textContent = NEW_TEXT;
    return true;
  }

  if (!renameHeader()) {
    const mo = new MutationObserver(() => renameHeader() && mo.disconnect());
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('SLIDECART_OPENED', renameHeader);
  }
});


// Remove quantity selector for FREEGIFT_HIDDEN items
document.addEventListener('SLIDECART_UPDATED', () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      cart.items.filter(i => i.product_type === 'FREEGIFT_HIDDEN')
        .forEach(i => {
          const s = document.querySelector(`.slidecarthq .item[data-variant-id="${i.variant_id}"] .quantity-selector`);
          if (s) s.remove();
        });
    });
});


// Replace $0.00 with "Free Gift"
function freeGift(){
  document
    .querySelectorAll('#slidecarthq .price-discount-block .price:not(.strike-through), .slidecarthq .price-discount-block .price:not(.strike-through)')
    .forEach(p => {
      const norm = (p.textContent || '').replace(/\s|\u00A0|\u202F/g,'');
      const digits = norm.replace(/\D/g,'');
      if (digits && /^0+$/.test(digits)) {
        const item = p.closest('.item');
        if (item) item.style.order = '1';
        p.textContent = 'Free Gift';
        p.style.fontWeight = '600';
      }
    });
}
document.addEventListener('SLIDECART_UPDATED', freeGift);


// Threshold-based product removal (SIN 4th gift)
const THRESHOLDS = [
  { amount: 15,  handles: ["free-fast-shipping"] },
  { amount: 70,  handles: ["free-electric-coffee-mixer"] },
  { amount: 95,  handles: ["free-skinny-coffee-tumbler"] }
];

// Regalos físicos que se permiten, pero SIN duplicarse
const PHYSICAL_GIFTS = [
  'free-skinny-coffee-tumbler',
  'free-electric-coffee-mixer'
];

// Handle del 4th gift a eliminar siempre
const REMOVED_HANDLES = ['night-collagen-burn-3'];

function removeProductFromCart(id) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, quantity: 0 })
  }).then(r => r.json()).then(() => {
    if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
  });
}

function changeQty(id, quantity) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id, quantity })
  }).then(r => r.json()).then(() => {
    if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
  });
}

async function enforceGiftRules(cart) {
  // Quitar 4th gift si aparece
  for (const it of cart.items) {
    if (REMOVED_HANDLES.includes(it.handle)) {
      await removeProductFromCart(it.key);
    }
  }

  // Deduplicar mixers/tumblers
  for (const handle of PHYSICAL_GIFTS) {
    const items = cart.items.filter(i => i.handle === handle);
    if (items.length > 0) {
      const [keep, ...dupes] = items;
      if (keep.quantity > 1) {
        await changeQty(keep.key, 1);
      }
      for (const d of dupes) {
        await removeProductFromCart(d.key);
      }
    }
  }
}

async function checkAndRemoveProducts(cart) {
  const total = cart.total_price / 100;

  for (const t of THRESHOLDS) {
    if (total < t.amount) {
      for (const h of t.handles) {
        const it = cart.items.find(i => i.handle === h);
        if (it) await removeProductFromCart(it.key);
      }
    }
  }

  await enforceGiftRules(cart);
}

window.SLIDECART_UPDATED = (cart) => {
  try {
    typeof autoAddGifts === 'function' && autoAddGifts();
    typeof getSCItemsInfo === 'function' && getSCItemsInfo(cart);
  } catch (e) { console.warn('[SC] Safe functions skipped', e); }

  checkAndRemoveProducts(cart);
  freeGift();
};


// Remove decimals in reward tiers
function updateRewardAmounts() {
  document.querySelectorAll(".rewards-tiers-labels-item-amount").forEach(el => {
    const v = parseFloat(el.textContent.replace("$", ""));
    if (!isNaN(v)) el.textContent = `$${Math.floor(v)}`;
  });
}

} // cierre del else del bloqueador
